/**
 * Globaler Notification-Stack — vom ToastStack.vue konsumiert.
 */
import { defineStore } from 'pinia';
import { ref } from 'vue';

export type ToastLevel = 'info' | 'success' | 'warn' | 'error';

export interface Toast {
  id: number;
  level: ToastLevel;
  message: string;
  /** ms — null = bleibt bis Klick. */
  ttl: number | null;
}

let nextId = 1;

export const useNotificationsStore = defineStore('notifications', () => {
  const toasts = ref<Toast[]>([]);

  function push(level: ToastLevel, message: string, ttl: number | null = 4000) {
    const id = nextId++;
    toasts.value.push({ id, level, message, ttl });
    if (ttl !== null) {
      setTimeout(() => dismiss(id), ttl);
    }
    return id;
  }

  function dismiss(id: number) {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  }

  return {
    toasts,
    push,
    dismiss,
    info: (m: string, ttl?: number | null) => push('info', m, ttl),
    success: (m: string, ttl?: number | null) => push('success', m, ttl),
    warn: (m: string, ttl?: number | null) => push('warn', m, ttl),
    error: (m: string, ttl?: number | null) => push('error', m, ttl ?? null),
  };
});
